import clsx from "clsx";
import * as global from "@components";
import { routesFlat } from "@routes";
import * as components from "./components";

export default function SolutionTemplate({ constants, animationData }) {
    const heroProps = {
        ...constants.hero,
        animationData,
        link: routesFlat.products,
    };
    const dataProps = {
        cards: constants.dataCards,
        header: "data in action",
        subheader: constants.dataSubheader,
    };

    return (
        <>
            {/* HEADER */}
            <global.MetaTagHeader {...constants.metaDataHeader} />
            <components.Hero {...heroProps} />

            <components.LatestMarquee
                articles={constants.latest || []}
                className="mb-10 lg:mb-0"
            />

            {/* TEXT IMG BEATS */}
            <components.ImgText {...constants.firstBeat} />
            <global.DottedDivider className={dividerStyle} />
            <components.ImgGreenText {...constants.secondBeat} />
            <global.DottedDivider className={dividerStyle} />
            <components.ImgText {...constants.thirdBeat} />
            <global.DottedDivider className={dividerStyle} />

            <div className="mt-20">
                <global.PartnerWithCTrees />
            </div>
            {/* DATA CAROUSEL */}
            <global.Data {...dataProps} />

            {/* PARTNER WITH CTREES */}
            <global.StayConnected />
        </>
    );
}

const dividerStyle = clsx("mx-10 my-8 md:hidden");
